import { httpV1 as http } from '@/services/api';

export async function previewConsolidated(data) {
  return http.post('/payoff/consolidated-bank-slip/preview', data);
}

export async function requestConsolidated(data) {
  return http.post('/payoff/consolidated-bank-slip', data);
}

export async function getConsolidatedStatus(id) {
  return http.get(`/payoff/consolidated-bank-slip/${id}`);
}
